
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.96 0C4.469 0 0 4.205 0 9.375c0 2.184.81 4.3 2.285 5.977.292 1.284-.063 2.644-.941 3.581-.368.392-.108 1.067.414 1.067 1.67 0 3.28-.698 4.475-1.928a10.43 10.43 0 003.728.678C15.453 18.75 20 14.545 20 9.375S15.454 0 9.96 0zM5.353 11.25c-.97 0-1.758-.841-1.758-1.875S4.382 7.5 5.352 7.5c.969 0 1.757.841 1.757 1.875s-.788 1.875-1.757 1.875zm4.687 0c-.97 0-1.758-.841-1.758-1.875S9.07 7.5 10.04 7.5c.97 0 1.758.841 1.758 1.875s-.789 1.875-1.758 1.875zm4.688 0c-.97 0-1.758-.841-1.758-1.875S13.757 7.5 14.727 7.5c.969 0 1.757.841 1.757 1.875s-.788 1.875-1.757 1.875z","fill":"#E2E8F0"}})])
          )
        }
      }
    